module.exports = __webpack_public_path__ + "media/images/game_icon/th/VGPHOENIX-8f59b61322705144ccd7ddec1b4fa206.png";